/**
 * SALES-FORECASTING MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// Public entry point for the sales-forecasting module. The app composition root imports
// ONLY from here; nothing deep-imports this module's internals.
import Forecasting from "./routes/Forecasting.jsx";
import { getDashboardSummary } from "./utils/dashboardSummary.js";

export const salesForecastingRoutes = [
  { path: "/forecasting", component: Forecasting },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "sales-forecasting", label: "Sales Forecasting" };

// Operations-hub (Home) contribution — Forecast next 30/60/90 days KPI.
export const dashboardProvider = getDashboardSummary;
